import './data/install-packs.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../../../design/system/tokens.css';
import './styles/tokens.css';
import './styles/base.css';
import './ui/ui.css';
import './styles/app.css';
import { App } from './app/App.tsx';
import { useAtlas } from './app/store.ts';
import { getViewport } from './viewport/host.ts';
import { lastCamera, on } from './viewport/events.ts';
import { fromQuery, syncUrl } from './app/url.ts';

// A Lab (`?lab=<id>`, src/labs/) is its own page: the frame's chunk mounts instead of the atlas, nothing of the scene
// is read from or written to the address bar, and the engine isn't started.
const labId = new URLSearchParams(location.search).get('lab');
if (labId !== null) {
  void import('./labs/boot.tsx').then((m) => m.mountLabs(labId));
} else {
  // The URL is the view: apply it before the viewport starts, then keep it current.
  fromQuery(location.search);
  syncUrl();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // For headless checks, screenshots and timing: read state, drive the store, reach the viewport and its
  // per-frame events (scripts/perf.ts times the engine's camera events).
  Object.assign(window, { __atlas: { store: useAtlas, viewport: getViewport, on, lastCamera } });
}
